import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find-index.js";
/* eslint-disable */
import editorStyle from "../util/defaultStyle";
var uniqBy = function uniqBy(arr, key) {
  var result = [];
  arr.forEach(function (i) {
    if (!result.find(function (r) {
      return r[key] === i[key];
    })) result.push(i);
  });
  return result;
};
export default function (G6) {
  G6.registerEdge('flow-polyline-round', {
    options: {
      style: _objectSpread({}, editorStyle.edgeStyle),
      stateStyles: {
        selected: {
          lineWidth: editorStyle.edgeSelectedStyle.lineWidth
        },
        hover: {
          stroke: editorStyle.edgeActivedStyle.stroke
        }
      }
    },
    setState: function setState(name, value, item) {
      var group = item.getContainer();
      var path = group.getChildByIndex(0);
      if (name === 'selected') {
        if (value) {
          path.attr('lineWidth', this.options.stateStyles.selected.lineWidth);
          path.attr('stroke', this.options.style.stroke);
        } else {
          path.attr('lineWidth', this.options.style.lineWidth);
        }
      } else if (name === 'hover') {
        if (value) path.attr('stroke', this.options.stateStyles.hover.stroke);else path.attr('stroke', this.options.style.stroke);
      }
    },
    drawShape: function drawShape(cfg, group) {
      this.group = group;
      var shapeStyle = this.getShapeStyle(cfg);
      var shape = group.addShape('path', {
        className: 'edge-shape',
        attrs: shapeStyle
      });
      return shape;
    },
    drawLabel: function drawLabel(cfg, group) {
      var labelCfg = cfg.labelCfg || {};
      var labelStyle = this.getLabelStyle(cfg, labelCfg, group);
      var label = group.addShape('text', {
        attrs: labelStyle
      });
      var labelBBox = label.getBBox();
      group.addShape('rect', {
        className: 'edge-labelRect',
        attrs: {
          x: labelBBox.x - editorStyle.edgeLabelRectPadding / 2,
          y: labelBBox.y - editorStyle.edgeLabelRectPadding / 2,
          width: labelBBox.width + editorStyle.edgeLabelRectPadding,
          height: labelBBox.height + editorStyle.edgeLabelRectPadding,
          fill: '#fff',
          stroke: '#fff'
        }
      });
      group.toBack();
      label.toFront();
      return label;
    },
    afterUpdate: function afterUpdate(cfg, item) {
      var label = item.getContainer().findByClassName('edge-label');
      var labelRect = item.getContainer().findByClassName('edge-labelRect');
      if (label) {
        var labelBBox = label.getBBox();
        labelRect.attr({
          x: labelBBox.x - editorStyle.edgeLabelRectPadding / 2,
          y: labelBBox.y - editorStyle.edgeLabelRectPadding / 2,
          width: labelBBox.width + editorStyle.edgeLabelRectPadding,
          height: labelBBox.height + editorStyle.edgeLabelRectPadding
        });
      }
    },
    getShapeStyle: function getShapeStyle(cfg) {
      cfg = this.getPathPoints(cfg);
      var startPoint = cfg.startPoint;
      var endPoint = cfg.endPoint;
      var controlPoints = this.getControlPoints(cfg);
      var points = [startPoint];
      if (controlPoints) {
        points = points.concat(controlPoints);
      }
      points.push(endPoint);
      var path = this.getPath(points);
      var style = this.options.style;
      if (cfg.reverse) style = _objectSpread(_objectSpread({}, style), {}, {
        lineDash: [1, 3]
      });else style = _objectSpread(_objectSpread({}, style), {}, {
        lineDash: null
      });
      return _objectSpread(_objectSpread({
        path: path
      }, style), {}, {
        endArrow: {
          path: 'M 0,0 L 6,-2 Q 5 0,6 2 Z',
          lineDash: [0, 0],
          fill: editorStyle.edgeStyle.stroke
        }
      });
    },
    getPath: function getPath(points) {
      var path = [];
      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        if (i === 0) {
          path.push(['M', point.x, point.y]);
        } else if (i === points.length - 1) {
          path.push(['L', point.x, point.y]);
        } else {
          var prevPoint = points[i - 1];
          var nextPoint = points[i + 1];
          var cornerLen = 5;
          if (Math.abs(point.y - prevPoint.y) > cornerLen || Math.abs(point.x - prevPoint.x) > cornerLen) {
            if (prevPoint.x === point.x) {
              path.push(['L', point.x, point.y > prevPoint.y ? point.y - cornerLen : point.y + cornerLen]);
            } else if (prevPoint.y === point.y) {
              path.push(['L', point.x > prevPoint.x ? point.x - cornerLen : point.x + cornerLen, point.y]);
            }
          }
          var yLen = Math.abs(point.y - nextPoint.y);
          var xLen = Math.abs(point.x - nextPoint.x);
          if (yLen > 0 && yLen < cornerLen) {
            cornerLen = yLen;
          } else if (xLen > 0 && xLen < cornerLen) {
            cornerLen = xLen;
          }
          if (prevPoint.x !== nextPoint.x && nextPoint.x === point.x) {
            path.push(['Q', point.x, point.y, point.x, point.y > nextPoint.y ? point.y - cornerLen : point.y + cornerLen]);
          } else if (prevPoint.y !== nextPoint.y && nextPoint.y === point.y) {
            path.push(['Q', point.x, point.y, point.x > nextPoint.x ? point.x - cornerLen : point.x + cornerLen, point.y]);
          }
        }
      }
      return path;
    },
    getControlPoints: function getControlPoints(cfg) {
      if (!cfg.sourceNode) {
        return cfg.controlPoints;
      }
      return this.polylineFinding(cfg.sourceNode, cfg.targetNode, cfg.startPoint, cfg.endPoint, 15);
    },
    getExpandedBBox: function getExpandedBBox(bbox, offset) {
      return 0 === bbox.width && 0 === bbox.height ? bbox : {
        centerX: bbox.centerX,
        centerY: bbox.centerY,
        minX: bbox.minX - offset,
        minY: bbox.minY - offset,
        maxX: bbox.maxX + offset,
        maxY: bbox.maxY + offset,
        height: bbox.height + 2 * offset,
        width: bbox.width + 2 * offset
      };
    },
    getExpandedPort: function getExpandedPort(bbox, point) {
      return Math.abs(point.x - bbox.centerX) / bbox.width > Math.abs(point.y - bbox.centerY) / bbox.height ? {
        x: point.x > bbox.centerX ? bbox.maxX : bbox.minX,
        y: point.y
      } : {
        x: point.x,
        y: point.y > bbox.centerY ? bbox.maxY : bbox.minY
      };
    },
    combineBBoxes: function combineBBoxes(sBBox, tBBox) {
      var minX = Math.min(sBBox.minX, tBBox.minX),
        minY = Math.min(sBBox.minY, tBBox.minY),
        maxX = Math.max(sBBox.maxX, tBBox.maxX),
        maxY = Math.max(sBBox.maxY, tBBox.maxY);
      return {
        centerX: (minX + maxX) / 2,
        centerY: (minY + maxY) / 2,
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY,
        height: maxY - minY,
        width: maxX - minX
      };
    },
    getBBoxFromVertexes: function getBBoxFromVertexes(sPoint, tPoint) {
      var minX = Math.min(sPoint.x, tPoint.x),
        maxX = Math.max(sPoint.x, tPoint.x),
        minY = Math.min(sPoint.y, tPoint.y),
        maxY = Math.max(sPoint.y, tPoint.y);
      return {
        centerX: (minX + maxX) / 2,
        centerY: (minY + maxY) / 2,
        maxX: maxX,
        maxY: maxY,
        minX: minX,
        minY: minY,
        height: maxY - minY,
        width: maxX - minX
      };
    },
    vertexOfBBox: function vertexOfBBox(bbox) {
      return [{
        x: bbox.minX,
        y: bbox.minY
      }, {
        x: bbox.maxX,
        y: bbox.minY
      }, {
        x: bbox.maxX,
        y: bbox.maxY
      }, {
        x: bbox.minX,
        y: bbox.maxY
      }];
    },
    crossPointsByLineAndBBox: function crossPointsByLineAndBBox(bbox, centerPoint) {
      var crossPoints = [];
      if (!(centerPoint.x < bbox.minX || centerPoint.x > bbox.maxX)) crossPoints = crossPoints.concat([{
        x: centerPoint.x,
        y: bbox.minY
      }, {
        x: centerPoint.x,
        y: bbox.maxY
      }]);
      if (!(centerPoint.y < bbox.minY || centerPoint.y > bbox.maxY)) crossPoints = crossPoints.concat([{
        x: bbox.minX,
        y: centerPoint.y
      }, {
        x: bbox.maxX,
        y: centerPoint.y
      }]);
      return crossPoints;
    },
    getConnectablePoints: function getConnectablePoints(sBBox, tBBox, sPoint, tPoint) {
      var _this = this;
      var lineBBox = this.getBBoxFromVertexes(sPoint, tPoint);
      var outerBBox = this.combineBBoxes(sBBox, tBBox);
      var sLineBBox = this.combineBBoxes(sBBox, lineBBox);
      var tLineBBox = this.combineBBoxes(tBBox, lineBBox);
      var points = [];
      points = points.concat(this.vertexOfBBox(sLineBBox), this.vertexOfBBox(tLineBBox), this.vertexOfBBox(outerBBox));
      var centerPoint = {
        x: outerBBox.centerX,
        y: outerBBox.centerY
      };
      [outerBBox, sLineBBox, tLineBBox, lineBBox].forEach(function (bbox) {
        points = points.concat(_this.crossPointsByLineAndBBox(bbox, centerPoint));
      });
      points.push({
        x: sPoint.x,
        y: tPoint.y
      });
      points.push({
        x: tPoint.x,
        y: sPoint.y
      });
      return points;
    },
    filterConnectablePoints: function filterConnectablePoints(points, bbox) {
      return points.filter(function (point) {
        return point.x <= bbox.minX || point.x >= bbox.maxX || point.y <= bbox.minY || point.y >= bbox.maxY;
      });
    },
    AStar: function AStar(points, sPoint, tPoint, sBBox, tBBox) {
      var _this2 = this;
      var openList = [sPoint];
      var closeList = [];
      points = uniqBy(this.fillId(points), 'id');
      points.push(tPoint);
      var endPoint;
      var _loop = function _loop() {
        var minCostPoint;
        openList.forEach(function (p, i) {
          if (!p.parent) p.f = 0;
          if (!minCostPoint) minCostPoint = p;
          if (p.f < minCostPoint.f) minCostPoint = p;
        });
        if (minCostPoint.x === tPoint.x && minCostPoint.y === tPoint.y) {
          endPoint = minCostPoint;
          return "break";
        }
        openList.splice(openList.findIndex(function (o) {
          return o.x === minCostPoint.x && o.y === minCostPoint.y;
        }), 1);
        closeList.push(minCostPoint);
        var neighbor = points.filter(function (p) {
          return (p.x === minCostPoint.x || p.y === minCostPoint.y) && !(p.x === minCostPoint.x && p.y === minCostPoint.y) && !_this2.crossBBox([sBBox, tBBox], minCostPoint, p);
        });
        neighbor.forEach(function (p) {
          var inOpen = openList.find(function (o) {
            return o.x === p.x && o.y === p.y;
          });
          var currentG = _this2.getCost(p, minCostPoint);
          if (closeList.find(function (o) {
            return o.x === p.x && o.y === p.y;
          })) {} else if (inOpen) {
            if (p.g > currentG) {
              p.parent = minCostPoint;
              p.g = currentG;
              p.f = p.g + p.h;
            }
          } else {
            p.parent = minCostPoint;
            p.g = currentG;
            var h = _this2.getCost(p, tPoint);
            if (_this2.crossBBox([tBBox], p, tPoint)) {
              h += tBBox.width / 2 + tBBox.height / 2; //如果穿过bbox则增加该点的预估代价为bbox周长的一半
            }

            p.h = h;
            p.f = p.g + p.h;
            openList.push(p);
          }
        });
      };
      while (openList.length > 0) {
        var _ret = _loop();
        if (_ret === "break") break;
      }
      if (endPoint) {
        var result = [];
        result.push({
          x: endPoint.x,
          y: endPoint.y
        });
        while (endPoint.parent) {
          endPoint = endPoint.parent;
          result.push({
            x: endPoint.x,
            y: endPoint.y
          });
        }
        return result.reverse();
      }
      return [];
    },
    crossBBox: function crossBBox(bboxes, p1, p2) {
      for (var i = 0; i < bboxes.length; i++) {
        var bbox = bboxes[i];
        if (p1.x === p2.x && bbox.minX < p1.x && bbox.maxX > p1.x) {
          if (p1.y < bbox.maxY && p2.y >= bbox.maxY || p2.y < bbox.maxY && p1.y >= bbox.maxY) return true;
        } else if (p1.y === p2.y && bbox.minY < p1.y && bbox.maxY > p1.y) {
          if (p1.x < bbox.maxX && p2.x >= bbox.maxX || p2.x < bbox.maxX && p1.x >= bbox.maxX) return true;
        }
      }
      return false;
    },
    getCost: function getCost(p1, p2) {
      return Math.abs(p1.x - p2.x) + Math.abs(p1.y - p2.y);
    },
    getPointBBox: function getPointBBox(t) {
      return {
        centerX: t.x,
        centerY: t.y,
        minX: t.x,
        minY: t.y,
        maxX: t.x,
        maxY: t.y,
        height: 0,
        width: 0
      };
    },
    fillId: function fillId(points) {
      points.forEach(function (p) {
        p.id = p.x + '-' + p.y;
      });
      return points;
    },
    polylineFinding: function polylineFinding(sNode, tNode, sPort, tPort, offset) {
      var sourceBBox = sNode && sNode.getBBox() ? sNode.getBBox() : this.getPointBBox(sPort);
      var targetBBox = tNode && tNode.getBBox() ? tNode.getBBox() : this.getPointBBox(tPort);
      var sBBox = this.getExpandedBBox(sourceBBox, offset);
      var tBBox = this.getExpandedBBox(targetBBox, offset);
      var sPoint = this.getExpandedPort(sBBox, sPort);
      var tPoint = this.getExpandedPort(tBBox, tPort);
      var points = this.getConnectablePoints(sBBox, tBBox, sPoint, tPoint);
      points = this.filterConnectablePoints(points, sBBox);
      points = this.filterConnectablePoints(points, tBBox);
      var polylinePoints = this.AStar(points, sPoint, tPoint, sBBox, tBBox);
      return polylinePoints;
    }
  }, 'polyline');
}